import { toFilterTree } from "./tree.js";
import type { FilterGroup } from "./types.js";

const CONVERT_URL = "/api/filter/convert";

export type FilterConversionResult = {
	filterObject: FilterGroup | null;
	filterString: string;
	whereClause: string;
	/** Set when the filter string could not be parsed into a structured filter. */
	warning?: string;
};

export type ConvertRequest = {
	filterObject?: FilterGroup | null;
	filterString?: string;
	/** Optional view name, used server-side to validate field names. */
	viewName?: string;
};

/**
 * Converts between a structured filter and a DevExpress filter string.
 *
 * The conversion is done server-side by `api/filter/convert`, because the
 * criteria string grammar is implemented by the licensed DevExpress parser that
 * the Windows client and the report engine use. Doing it in the browser would
 * risk producing strings the server cannot parse back.
 */
export async function convertFilter(request: ConvertRequest, signal?: AbortSignal): Promise<FilterConversionResult> {
	let response = await fetch(CONVERT_URL, {
		method: "POST",
		headers: { "Content-Type": "application/json" },
		body: JSON.stringify(request),
		signal,
	});

	if (!response.ok) {
		throw new Error(`Failed to convert filter: ${response.status} ${response.statusText}`);
	}

	let result = (await response.json()) as FilterConversionResult;

	return {
		...result,
		filterObject: result.filterObject ? toFilterTree(result.filterObject) : null,
	};
}
